module.exports = __webpack_public_path__ + "img/05.6a06098f.png";